import { Refused } from './refused';
import { GenericError } from './generic-error';
import { NoPairedDevice } from './no-paired-device';
import { Waiting } from './waiting';
import { EnforceQRCode } from './enforce-qr-code';

export const Sca = { EnforceQRCode, Refused, GenericError, NoPairedDevice, Waiting };
